import { RestaurantNav } from "./RestaurantNav";

export default RestaurantNav;
